import { type FragmentOf, readFragment } from "@opensea/graphql"
import { useHeroHeaderChipVariant } from "@/components/hero-header/use-hero-header-chip-variant"
import { ProfileAddressChip } from "./chips/ProfileAddressChip"
import { ProfileBetaTesterChip } from "./chips/ProfileBetaTesterChip"
import { ProfileCoinbaseOneChip } from "./chips/ProfileCoinbaseOneChip"
import { ProfileENSChip } from "./chips/ProfileENSChip"
import { ProfileIsStaffChip } from "./chips/ProfileIsStaffChip"
import { ProfileJoinedAtChip } from "./chips/ProfileJoinedAtChip"
import { ProfileMetadataChipFragment } from "./ProfileMetadataChip.fragment"

export type ProfileMetadataChip =
  | "joined_at"
  | "address"
  | "ens_name"
  | "beta_tester"
  | "coinbase_one"
  | "is_staff"

export type ProfileMetadataChipProps = {
  profile: FragmentOf<typeof ProfileMetadataChipFragment>
  chip: ProfileMetadataChip
  variant?: "compact" | "full"
}

export function ProfileMetadataChip({
  chip,
  profile: profileKey,
  variant = "full",
  ...rest
}: ProfileMetadataChipProps) {
  const profile = readFragment(ProfileMetadataChipFragment, profileKey)
  const chipVariant = useHeroHeaderChipVariant()

  switch (chip) {
    case "joined_at":
      return (
        <ProfileJoinedAtChip
          profile={profile}
          {...rest}
          chipVariant={chipVariant}
          variant={variant}
        />
      )
    case "address":
      return (
        <ProfileAddressChip profile={profile} {...rest} variant={chipVariant} />
      )
    case "ens_name":
      return (
        <ProfileENSChip profile={profile} {...rest} variant={chipVariant} />
      )
    case "beta_tester":
      return (
        <ProfileBetaTesterChip
          profile={profile}
          {...rest}
          chipVariant={chipVariant}
          variant={variant}
        />
      )
    case "coinbase_one":
      return (
        <ProfileCoinbaseOneChip chipVariant={chipVariant} profile={profile} />
      )
    case "is_staff":
      return <ProfileIsStaffChip chipVariant={chipVariant} profile={profile} />
  }
}
